import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { FaMapLocationDot } from "react-icons/fa6";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const TerrainForm = ({ utilisateurId }) => {
  const TERRAIN_CATEGORIE_ID = CATEGORIES.find(cat => cat.label === "Terrain")?.id;

  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true); // Ouvre le modal au chargement de la page
  }, []);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    surface: "",
    ville: "",
    transaction: "",
    frequenceLoyer: "",
    images: [],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "transaction" && value !== "Location") {
        updated.frequenceLoyer = "";
      }
      return updated;
    });
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, images: e.target.files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", TERRAIN_CATEGORIE_ID)
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      if (key === "images") {
        for (let i = 0; i < formData.images.length; i++) {
          dataToSend.append("images", formData.images[i]);
        }
      } else {
            if ((key === "frequenceLoyer" && formData.transaction !== "Location") || formData[key] === "") return;

        dataToSend.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          surface: "",
          ville: "",
          transaction: "",
          typeTerrain: "",
          frequenceLoyer: "",
          images: [],
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <FaMapLocationDot />
        <h2>Créer une annonce pour un terrain :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />

        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />
        {errors.transaction && (
          <span className="error">
            Veuillez renseigner le type de transaction
          </span>
        )}
        <select
          name="transaction"
          onChange={handleChange}
          value={formData.transaction}
        >
          <option value="">Type de transaction</option>
          <option value="Location">Location</option>
          <option value="Achat">Achat</option>
        </select>

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />
          {formData.transaction === "Location" && (
            <select
              className="frequenceSelect"
              name="frequenceLoyer"
              onChange={handleChange}
            >
              <option value="">Périodicité</option>
              <option value="Jour">Jour</option>
              <option value="Semaine">Semaine</option>
              <option value="Mois">Mois</option>
            </select>
          )}
          <label>FCFA</label>
        </div>
        <input
          type="number"
          name="surface"
          placeholder="Surface"
          onChange={handleChange}
          value={formData.surface}
        />
        <input
          type="text"
          name="ville"
          placeholder="Ville du terrain"
          onChange={handleChange}
          value={formData.ville}
        />

        <select
          name="typeTerrain"
          onChange={handleChange}
          value={formData.typeTerrain}
        >
          <option value="">Type de terrain</option>
          <option value="Constructible">Constructible</option>
          <option value="Non constructible">Non constructible</option>
        </select>

        <input
          type="file"
          name="images"
          multiple
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        <button className="button" type="submit">
          Créer l'annonce
        </button>

                {formData.transaction === "Achat" ? (
          <span>Prix de l'annonce : 5000 Francs CFA</span>
        ) : (
        <span>Prix de l'annonce : 2000 Francs CFA</span>
        )}
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default TerrainForm;
